import type { z } from 'zod';

import type { LessonEnrolmentSchema } from './schemas';

type LessonEnrolmentField = keyof z.infer<typeof LessonEnrolmentSchema>;

const listAttributes = [
  'id',
  'studentId',
  'subject',
  'classCode',
  'courseId',
  'lessonTemplateCode',
  'counter',
  'lessonId',
  'classId',
  'classLabel',
  'present',
  'homework',
  'enrolmentMethod',
  'attendanceType',
  'startDatetime',
  'attendanceNotified',
  'billingType',
  'rollMarked',
  'separatelyBilled',
  'streamId',
] as const satisfies readonly LessonEnrolmentField[];

const getAttributes = [...listAttributes] as const satisfies readonly LessonEnrolmentField[];

const updateAttributes = [
  'present',
  'homework',
  'enrolmentMethod',
  'attendanceType',
  'attendanceNotified',
] as const satisfies readonly LessonEnrolmentField[];

export const LessonEnrolmentAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};
